import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import '../../fonts/century_751_semi_bold.ttf'; 
import '../../fonts/Weissenhof Grotesk W01 Regular.ttf'; 



import './ModalP.css';

function MyVerticallyCenteredModal(props) {
    

    
    return (
        <div  >
        <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Terms and Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <h5>Introduction</h5>
          <div>
              <p>
                These terms and conditions govern your use of this website; by using this website, you
                accept these terms and conditions in full. If you disagree with these terms and conditions or
                any part of these terms and conditions, you must not use this website.
              </p>
              <p>
                You must be at least 18 years of age to use this website. By using this website and by
                agreeing to these terms and conditions you warrant and represent that you are at least 18
                years of age.
              </p>
              <p>
                This website uses cookies. By using this website and agreeing to these terms and conditions,
                you consent to our SAISHREYASRESIDENCY.COM’s use of cookies in accordance with the
                terms of SAISHREYASRESIDENCY.COM’s privacy policy / cookies policy.
              </p>
          </div>
          
          <div>
            <h5>Licence to use Website</h5>
            <p>
            Unless otherwise stated, SAISHREYASRESIDENCY.COM and/or its licensors own the
            intellectual property rights in the website and material on the website. Subject to the
            license below, all these intellectual property rights are reserved.
            </p>
            <p>
            You may view; download for caching purposes only, and print pages or OTHER CONTENT
            from the website for your own personal use, subject to the restrictions set out below and
            elsewhere in these terms and conditions.
            </p>
            <h5>You must not:</h5>
            <p>
              Republish material from this website (including republication on another website); sell, rent
              or sub-license material from the website; show any material from the website in public;
              reproduce, duplicate, copy or otherwise exploit material on this website for a commercial
              purpose; edit or otherwise modify any material on the website; or redistribute material
              from this website except for content specifically and expressly made available for
              redistribution. Note: Where content is specifically made available for redistribution, it may
              only be redistributed within your organisation.
            </p>
            <h5>Acceptable Use</h5>
            <p>
              You must not use this website in any way that causes, or may cause, damage to the website
              or impairment of the availability or accessibility of the website; or in any way which is
              unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal,
              fraudulent or harmful purpose or activity.
            </p>
            <p>
              You must not use this website to copy, store, host, transmit, send, use, publish or distribute
              any material which consists of (or is linked to) any spyware, computer virus, Trojan horse,
              worm, keystroke logger, rootkit or other malicious computer software.
            </p>
            <p>
              You must not conduct any systematic or automated data collection activities (including
              without limitation scraping, data mining, data extraction and data harvesting) on or in
              relation to this website without SAISHREYASRESIDENCY.COM’s express written consent.
            </p>
            <p>
              You must not use this website to transmit or send unsolicited commercial communications.
            </p>
            <p>
              You must not use this website for any purposes related to marketing without
              SAISHREYASRESIDENCY.COM’s express written consent.
            </p>
            <h5>Restricted Access</h5>
            <p>
              Access to certain areas of this website may be restricted. SAISHREYASRESIDENCY.COM
              reserves the right to restrict access to other areas of this website, or indeed this entire
              website, at SAISHREYASRESIDENCY.COM’s discretion.
            </p>
            <p>
              If SAISHREYASRESIDENCY.COM provides you with a user ID and password to enable you to
              access restricted areas of this website or other content or services, you must ensure that
              the user ID and password are kept confidential.
            </p>
            <p>
              SAISHREYASRESIDENCY.COM may disable your user ID and password in
              SAISHREYASRESIDENCY.COM’s sole discretion without notice or explanation.
            </p>
            <h5>User Content</h5>
            <p>
              In these terms and conditions, “your user content” means material (including without
              limitation text, images, audio material, video material and audio-visual material) that you
              submit to this website, for whatever purpose.
            </p>
            <p>
              You grant to SAISHREYASRESIDENCY.COM a worldwide, irrevocable, non-exclusive, royalty-
              free license to use, reproduce, adapt, publish, translate and distribute your user content in
              any existing or future media. You also grant to SAISHREYASRESIDENCY.COM the right to sub-
              license these rights, and the right to bring an action for infringement of these rights.
            </p>
            <p>
              Your user content must not be illegal or unlawful, must not infringe any third party’s legal
              rights, and must not be capable of giving rise to legal action whether against you or
              SAISHREYASRESIDENCY.COM or a third party (in each case under any applicable law).
            </p>
            <p>
              You must not submit any user content to the website that is or has ever been the subject of
              any threatened or actual legal proceedings or other similar complaint.
            </p>
            <p>
              SAISHREYASRESIDENCY.COM reserves the right to edit or remove any material submitted to
              this website, or stored on SAISHREYASRESIDENCY.COM’s servers, or hosted or published
              upon this website.
            </p>
            <p>
              Notwithstanding SAISHREYASRESIDENCY.COM’s rights under these terms and conditions in
              relation to user content, SAISHREYASRESIDENCY.COM does not undertake to monitor the
              submission of such content to, or the publication of such content on, this website.
            </p>
            <h5>No Warranties</h5>
            <p>
              This website is provided “as is” without any representations or warranties, express or
              implied. SAISHREYASRESIDENCY.COM makes no representations or warranties in relation to
              this website or the information and materials provided on this website.
            </p>
            <p>
              Without prejudice to the generality of the foregoing paragraph, SAISHREYASRESIDENCY.COM does 
              not warrant that:
            </p>
            <p>
              This website will be constantly available, or available at all; or the information on this
              website is complete, true, accurate or non-misleading. Nothing on this website constitutes,
              or is meant to constitute, advice of any kind. If you require advice in relation to any [legal,
              financial or medical] matter you should consult an appropriate professional.
            </p>
            <h5>Limitations of liability</h5>
            <p>
                SAISHREYASRESIDENCY.COM will not be liable to you (whether under the law of contact, the
                law of torts or otherwise) in relation to the contents of, or use of, or otherwise in
                connection with, this website: to the extent that the website is provided free-of-charge, for
                any direct loss; for any indirect, special or consequential loss; or for any business losses, loss
                of revenue, income, profits or anticipated savings, loss of contracts or business
                relationships, loss of reputation or goodwill, or loss or corruption of information or data.
                These limitations of liability apply even if SAISHREYASRESIDENCY.COM has been expressly
                advised of the potential loss.
            </p>
            <h5>Exceptions</h5>
            <p>
                Nothing in this website disclaimer will exclude or limit any warranty implied by law that it
                would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or
                limit SAISHREYASRESIDENCY.COM’s liability in respect of any: Death or personal injury
                caused by SAISHREYASRESIDENCY.COM’s negligence; Fraud or fraudulent misrepresentation
                on the part of SAISHREYASRESIDENCY.COM; or Matter which it would be illegal or unlawful
                for SAISHREYASRESIDENCY.COM to exclude or limit, or to attempt or purport to exclude or
                limit, its liability.
            </p>
            <h5>Reasonableness</h5>
            <p>
              By using this website, you agree that the exclusions and limitations of liability set out in this
              website disclaimer are reasonable.
            </p>
            <p>
              If you do not think they are reasonable, you must not use this website.
            </p>
            <h5>Other Parties</h5>
            <p>
              You accept that, as a limited liability entity, SAISHREYASRESIDENCY.COM has an interest in
              limiting the personal liability of its directors, officers and employees. You agree that you will
              not bring any claim personally against SAISHREYASRESIDENCY.COM’s directors, officers or
              employees in respect of any losses you suffer in connection with the website.
            </p>
            <p>
              Without prejudice to the foregoing paragraph, you agree that the limitations of warranties
              and liability set out in this website disclaimer will protect SAISHREYASRESIDENCY.COM’s
              directors, officers, employees, agents, subsidiaries, successors, assigns and sub-contractors
              as well as SAISHREYASRESIDENCY.COM.
            </p>
            <h5>Unenforceable Provisions</h5>
            <p>
              If any provision of this website disclaimer is, or is found to be, unenforceable under
              applicable law, that will not affect the enforceability of the other provisions of this website
              disclaimer.
            </p>
            <h5>Indemnity</h5>
            <p>
              You hereby indemnify SAISHREYASRESIDENCY.COM and undertake to keep
              SAISHREYASRESIDENCY.COM indemnified against any losses, damages, costs, liabilities and
              expenses (including without limitation legal expenses and any amounts paid by
              SAISHREYASRESIDENCY.COM to a third party in settlement of a claim or dispute on the
              advice of SAISHREYASRESIDENCY.COM’s legal advisers) incurred or suffered by
              SAISHREYASRESIDENCY.COM arising out of any breach by you of any provision of these
              terms and conditions, or arising out of any claim that you have breached any provision of
              these terms and conditions.
            </p>
            <h5>Breaches of these Terms and Conditions</h5>
            <p>
                Without prejudice to SAISHREYASRESIDENCY.COM’s other rights under these terms and
                conditions, if you breach these terms and conditions in any way,
                SAISHREYASRESIDENCY.COM may take such action as SAISHREYASRESIDENCY.COM deems
                appropriate to deal with the breach, including suspending your access to the website,
                prohibiting you from accessing the website, blocking computers using your IP address from
                accessing the website, contacting your internet service provider to request that they block
                your access to the website and/or bringing court proceedings against you.
            </p>
            <h5>Variation</h5>
            <p>
                SAISHREYASRESIDENCY.COM may revise these terms and conditions from time-to-time.
                Revised terms and conditions will apply to the use of this website from the date of the
                publication of the revised terms and conditions on this website. Please check this page
                regularly to ensure you are familiar with the current version.
            </p>
            <h5>Assignment</h5>
            <p>
              SAISHREYASRESIDENCY.COM may transfer, sub-contract or otherwise deal with
              SAISHREYASRESIDENCY.COM’s rights and/or obligations under these terms and conditions
              without notifying you or obtaining your consent.
            </p>
            <p>
              You may not transfer, sub-contract or otherwise deal with your rights and/or obligations
              under these terms and conditions.
            </p>
            <h5>Severability</h5>
            <p>
              If a provision of these terms and conditions is determined by any court or other competent
              authority to be unlawful and/or unenforceable, the other provisions will continue in effect.
              If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it
              were deleted, that part will be deemed to be deleted, and the rest of the provision will
              continue in effect.
            </p>
            <h5>Entire Agreement</h5>
            <p>
              These terms and conditions, together with relevant DOCUMENTS uploaded on the website,
              constitute the entire agreement between you and SAISHREYASRESIDENCY.COM in relation
              to your use of this website, and supersede all previous agreements in respect of your use of
              this website.
            </p>
            <h5>Law and Jurisdiction</h5>
            <p>
              These terms and conditions will be governed by and construed in accordance with laws of
              INDIA and any disputes relating to these terms and conditions will be subject to the non-
              exclusive jurisdiction of the courts of (INDIA).
            </p>
            <h5>SAISHREYASRESIDENCY.COM’s details</h5>
            <p>
              The full name of SAISHREYASRESIDENCY.COM is SAI SHREYAS RESIDENCY
            </p>
            <p>
              #371/11, Kadiganahalli Gate, Kempegowda International Airport Road, Near Decathlon
              Anubhava, Chikkajala, Bengaluru, Karnataka 562157
            </p>
            <p>
              You can contact SAISHREYASRESIDENCY.COM by email to INFO@SAISHREYASRESIDENCY.COM.
            </p>
            <p>
              We believe in continuous interaction with each one of student who undergo our training
              program . We will coordinate events which can help each young student to interact with
              successful individual in the society and participate in social events .A part of our profit will
              be kept aside for various charity works in which we will actively participate young
              generations. We will coordinate activities to create and experience social responsibility and
              values.
            </p>
          </div>
          
        </Modal.Body>
        <Modal.Footer>
          <Button className='closeBtn' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
        </div>
      
    );
  }





export default MyVerticallyCenteredModal
